import type { SubflowTemplateFormDTO } from '@conversed/rest/src/contracts/subflow-templates/subflow-templates.dto';
import { getBlocksWithNewIdAndSubFlow } from '@helpers/flowHelper';
import { useBlocks } from '@hooks/flow/block/useBlocks';
import { useSubflowTemplateActions } from '@hooks/subflow-templates/useSubflowTemplateActions';
import type React from 'react';
import { useCallback } from 'react';
import SubflowTemplateData from './SubflowTemplateData';

interface Props {
  subflowName: string;
}

export const SaveSubflowTemplate: React.FC<Props> = ({ subflowName }) => {
  const { createSubflowTemplate } = useSubflowTemplateActions();
  const { getBlocksBySubflow } = useBlocks();

  const onSubmit = useCallback(
    async (data: SubflowTemplateFormDTO) => {
      const blocks = getBlocksBySubflow(subflowName);

      // Omit the blocks revision id, we don't need to save the current revision id in the subflow template
      const updatedBlocks = getBlocksWithNewIdAndSubFlow(
        blocks,
        data.name,
        undefined,
      );

      await createSubflowTemplate({ ...data, blocks: updatedBlocks });
    },
    [subflowName, getBlocksBySubflow, createSubflowTemplate],
  );

  return <SubflowTemplateData onSubmit={onSubmit} />;
};

export default SaveSubflowTemplate;
